<template>
  <section>
    <errors-list :errorMessage="errorMessage" />
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-lg class="ma-0 pa-0">
              <v-layout row wrap justify-start align-center>
                <v-flex style="font-size: 12px" v-if="$props.recommendation">
                  <v-checkbox
                    v-model="$props.recommendation.isEnsured"
                    :label="$t('@newContractForm/customerIsEnsured')"
                    color="green darken-1"
                    class="mt-0"
                    style="font-size: 12px"
                    label-style="font-size: 12px"
                    disabled
                    required
                    hide-details
                  />
                  <v-checkbox
                    v-model="$props.recommendation.onDirectDebit"
                    :label="$t('@newContractForm/customerIsOkWithDirectDebit')"
                    color="green darken-1"
                    class="mt-0"
                    disabled
                    required
                    hide-details
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card v-if="showCost" flat xs6 class="pb-2">
          <v-divider></v-divider>
          <v-card-title class="subheading font-weight-medium pb-0">
            {{ $t('@newContractForm/recommendationForProduct') }}
          </v-card-title>
          <v-flex xs6>
            <v-list dense>
              <v-list-tile>
                <v-list-tile-content>{{ $t('@newContractForm/loanCosts') }}:</v-list-tile-content>
                <v-list-tile-content class="align-end">
                  {{ $props.recommendation.loanCost }}
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  {{ $t('@newContractForm/housingCosts') }}:
                </v-list-tile-content>
                <v-list-tile-content class="align-end">
                  {{ $props.recommendation.housingCost }}
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>{{ $t('@newContractForm/otherCosts') }}:</v-list-tile-content>
                <v-list-tile-content class="align-end">
                  {{ $props.recommendation.otherCost }}
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile class="subheading font-weight-medium">
                <v-list-tile-content class="subheading font-weight-medium">
                  {{ $t('@newContractForm/recommendationTotal') }}:
                </v-list-tile-content>
                <v-list-tile-content class="align-end subheading font-weight-medium">
                  {{ recommendationSum }}
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import ErrorsList from '../../components/ErrorsList';

export default {
  components: { ErrorsList },

  props: {
    recommendation: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      errorMessage: '',
    };
  },

  computed: {
    recommendationSum() {
      const { loanCost, housingCost, otherCost } = this.$props.recommendation;
      return Number(loanCost) + Number(housingCost) + Number(otherCost);
    },
    showCost() {
      return !!(this.$props.recommendation && this.$props.recommendation.loanCost);
    },
  },
};
</script>
<style scoped>
>>> .v-label {
  font-size: 12px;
}
</style>
